import { createReducer, on } from "@ngrx/store";
import { DeviceManufacturerStateInterface } from "src/app/devices/models/device-manufacturer-state-interface";
import * as DeviceManufacturerActions from "./device-manufacturers-actions";

export const initialState: DeviceManufacturerStateInterface = {
    isLoading: false,
    deviceManufacturers: [],
    total: 0,
    error: null,
};

export const deviceManufacturersReducers = createReducer(
    initialState, 

    // get Device Manufacturers
    on(DeviceManufacturerActions.getDeviceManufacturers, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceManufacturerActions.getDeviceManufacturersSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        deviceManufacturers: action.deviceManufacturers.slice().sort((a, b) => a.name.localeCompare(b.name)),
        total: action.total
    })),
    on(DeviceManufacturerActions.getDeviceManufacturersFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // search Device Manufacturers
    on(DeviceManufacturerActions.searchDeviceManufacturers, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceManufacturerActions.searchDeviceManufacturersSuccess, (state, action) => ({
        ...state, 
        isLoading: false, 
        deviceManufacturers: action.deviceManufacturers,
        total: action.total
    })),
    on(DeviceManufacturerActions.searchDeviceManufacturersFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // create Device Manufacturer
    on(DeviceManufacturerActions.createDeviceManufacturer, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceManufacturerActions.createDeviceManufacturerSuccess, (state, action) => ({
        ...state, 
        isLoading: false,
        deviceManufacturers: [...state.deviceManufacturers, action.deviceManufacturer].sort((a, b) => a.name.localeCompare(b.name)),
        total: state.total + 1
    })),
    on(DeviceManufacturerActions.createDeviceManufacturerFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // update Device Manufacturer
    on(DeviceManufacturerActions.updateDeviceManufacturer, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceManufacturerActions.updateDeviceManufacturerSuccess, (state, action) => {
        const updatedManufacturerIndex = state.deviceManufacturers.findIndex(category => category.id === action.deviceManufacturer.id);
        
        if (updatedManufacturerIndex === -1) {
            return state; // If category not found, return current state
        }

        const updatedManufacturers = [...state.deviceManufacturers];
        updatedManufacturers[updatedManufacturerIndex] = action.deviceManufacturer;

        return {
            ...state,
            isLoading: false,
            deviceManufacturers: updatedManufacturers.sort((a, b) => a.name.localeCompare(b.name))
        };
    }),
    on(DeviceManufacturerActions.updateDeviceManufacturerFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),

    // delete Device Manufacturer
    on(DeviceManufacturerActions.deleteDeviceManufacturer, (state) => ({
        ...state, 
        isLoading: true
    })),
    on(DeviceManufacturerActions.deleteDeviceManufacturerSuccess, (state,action) => ({
        ...state, 
        isLoading: false,
        deviceManufacturers: state.deviceManufacturers.filter(category => category.id !== action.id),
        total: state.total - 1
      })),
    on(DeviceManufacturerActions.deleteDeviceManufacturerFailure, (state, action) => ({
        ...state, 
        isLoading: false,
        error: action.error
    })),
);